import React from "react";
import { handleDateSetUp } from "../../../../helpers/helpers";

function SpecificDate({ specificDates, toolValue }) {

  return (
    <div className="pointer" data-tooltip-id={toolValue}>
      {specificDates?.map((item) => (
        <span className="" key={item}>
          {handleDateSetUp(item)},{" "}
        </span>
      ))}
    </div>
  );
}

export default SpecificDate;
